import React from 'react'

import cx from 'classnames'

import { ProgressiveLoader } from '@driftt/tide-core'

import { Size, Theme } from '.'

import styles from './styles.module.css'

const TOP_ROW_SIZE = [100, 120, 190, 250]

const BOTTOM_ROW_SIZE = [40, 80, 100, 150]

const getRandomSize = (array: number[]) => () => array[Math.floor(Math.random() * array.length)]

const getRandomTopSize = getRandomSize(TOP_ROW_SIZE)
const getRandomBottomSize = getRandomSize(BOTTOM_ROW_SIZE)

interface Props {
  index?: number
  className?: string
  theme?: Theme
  size?: Size
  shape?: JSX.Element[] | JSX.Element
}

const Shimmer: React.FC<Props> = ({ index, className, theme, size, shape }): JSX.Element => {
  const placeholderShape = [
    <circle key={0} cx="16" cy="16" r="16" />,
    <rect
      key={1}
      x="40"
      y="0"
      width={size === Size.RANDOM ? getRandomTopSize() : 120}
      height="16"
      rx="4"
    />,
    <rect
      key={2}
      x="40"
      y="24"
      width={size === Size.RANDOM ? getRandomBottomSize() : 80}
      height="9"
      rx="2"
    />,
  ]

  const options = {
    primaryColor: theme === Theme.LIGHT ? 'var(--color-p1-4)' : 'var(--color-p1-8)',
    secondaryColor: theme === Theme.LIGHT ? 'var(--color-p1-5)' : 'var(--color-p1-6)',
    primaryOpacity: 1,
    secondaryOpacity: 1,
    delayKey: index,
    width: 250,
  }

  return (
    <div className={cx(className, styles.Shimmer)}>
      <ProgressiveLoader
        options={options}
        placeholderShape={shape || placeholderShape}
        numPlaceholders={1}
      />
    </div>
  )
}

export default Shimmer
